import { render, staticRenderFns } from "./math-topics-page.vue?vue&type=template&id=b4bc42ce&"
import script from "./math-topics-page.vue?vue&type=script&lang=js&"
export * from "./math-topics-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports